<style lang="scss">
    // @import 'bootstrap/scss/bootstrap-grid';
    .eqs-cms-irtool-app {
        position: relative;
        width: 100%;
        height: 100%;
        color: #333;
        margin: 0;
        padding: 8px;
        box-sizing: border-box;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
            Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
        :global(a) {
            color: rgb(0, 100, 200);
            text-decoration: none;
        }

        :global(a:hover) {
            text-decoration: underline;
        }

        :global(a:visited) {
            color: rgb(0, 80, 160);
        }

        :global(label) {
            display: block;
        }

        :global(input),
        :global(button),
        :global(select),
        :global(textarea) {
            font-family: inherit;
            font-size: inherit;
            -webkit-padding: 0.4em 0;
            padding: 0.4em;
            margin: 0 0 0.5em 0;
            box-sizing: border-box;
            border: 1px solid #ccc;
            border-radius: 2px;
        }

        :global(input:disabled) {
            color: #ccc;
        }

        :global(button) {
            color: #333;
            background-color: #f4f4f4;
            outline: none;
            cursor: pointer;
        }

        :global(button:disabled) {
            color: #999;
        }

        :global(button:not(:disabled):active) {
            background-color: #ddd;
        }

        :global(button:focus) {
            border-color: #666;
        }
        :global(.error) {
            color: red;
            display: block;
            margin-bottom: 5px;
            margin-top: 0;
        }
    }
</style>

<script lang="ts">
    import { configureAuth } from '@eqs/cms-svelte-irtools';

    import { onMount } from 'svelte';
    import ConfirmSubscription from './components/ConfirmSubscription/ConfirmSubscription.svelte';
    import ContactForm from './components/ContactForm/ContactForm.svelte';
    import * as config from './config';
    import './i18n';

    let token: string | null = null;
    onMount(() => {
        const urlParams = new URLSearchParams(window.location.search);
        token = urlParams.get(config.SUBSCRIPTION_TOKEN_PARAM_NAME);
        configureAuth({
            provision_key: config.AUTH_PROVISION_KEY,
            response_type: config.AUTH_RESPONSE_TYPE,
            authenticated_userid: config.AUTH_AUTHENTICATED_USER_ID,
            client_id: config.AUTH_CLIENT_ID
        });
    });
</script>

<div class="eqs-cms-irtool-app">
    {#if token}
        <ConfirmSubscription token="{token}" />
    {:else}
        <ContactForm />
    {/if}
</div>
